<template>
  <table class="cus-eval-score" :name="options.Key">
    <colgroup>
      <col style="width: 150px">
      <col v-for="(obj, i) in options.TableColumns" :key="i" :style="colWidth">
      <col style="width: 80px">
    </colgroup>
    <tbody>
      <tr class="cus-table-thead">
        <th>评分项目</th>
        <th v-for="(column, i) in options.TableColumns" :key="i">
          {{column.Name}}
        </th>
        <th>操作</th>
      </tr>
      <template v-for="(obj, i) in rows" :key="i">
        <tr v-for="(item, j) in obj.data" :key="100 * i + j">
          <td v-if="!j" :rowspan="obj.data.length">
            <p class="tsw-p">{{obj.EVAL_NAME}}</p>
          </td>
          <td v-for="(column, k) in options.TableColumns" :key="k" style="vertical-align: top">
            <p class="text-center">
              <el-form-item v-msg class="tender-form-label wp100" style="margin: 0" label-width="0" :prop="`${options.Key}.${i}.data.${j}.${column.Key}`" :name="column.Key" :rules="ruless[i][column.Key]">
                <bear-input v-model="item[column.Key]" @input="inputChangeHandle" :attrs="inputAttrs"></bear-input>
              </el-form-item>
            </p>
          </td>
          <td>
            <el-button v-if="j === 0" type="primary" size="small" @click="addRow(i)">添加</el-button>
            <el-button v-else type="danger" size="small" @click="delRow(i, j)">删除</el-button>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import formUtils from '../../../js/formUtils'
import BearInput from '~@/input/src'
export default {
  name: 'FormEvalScoreSzsj',
  components: {
    BearInput,
  },
  mixins: [mixForFormItem],
  computed: {
    colLength() {
      return this.options.TableColumns.length
    },
    colWidth() {
      return `width: ${600 / this.colLength}px`
    },
    inputAttrs() {
      return {
        minWidth: `${600 / this.colLength - 40}px`
      }
    },
    value() {
      let {options, form} = this
      return form[options.Key] || []
    },
    ruless() {
      return this.rows.map((obj, index) => {
        return this.options.TableColumns.reduce((pre, cur) => {
          pre[cur.Key] = formUtils.initFormRules(cur, this, this.param, { index })
          return pre
        }, {})
      })
      
    }
  },
  data() {
    return {
      rows: []
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(options.Value) {
          form[options.Key] = options.Value
          this.rows = options.Value
        } else {
          form[options.Key] = this.rows
        }
        this.$nextTick(() => {
          this.doValidate()
        })
      }).catch(() => {
        this.rows = form[options.Key] || []
        this.$nextTick(() => {
          this.doValidate()
        })
      })
    },
    inputChangeHandle() {
      this.doValidate()
    },
    getRequiredCount() {
      const columnLength = this.options.TableColumns.length
      return this.rows.reduce((pre, cur) => pre + cur.data.length * columnLength, 0)
    },
    addRow(i) {
      const { TableColumns } = this.options
      const list = this.rows[i].data
      list.push(TableColumns.reduce((pre, cur) => {
        pre[cur.Key] = ''
        return pre
      }, { id: list.length + 1 }))
      this.resetId()
    },
    delRow(i, j) {
      this.rows[i].data.splice(j, 1)
      this.resetId()
    },
    resetId() {
      this.rows.forEach(obj => {
        obj.data.forEach((o, j) => {
          o.id = j + 1
        })
      })
      this.doValidate()
    }
  },
  watch: {
    value() {
      this.rows = this.value
      this.$nextTick(() => {
        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss" scope>
.cus-eval-score {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  thead, .cus-table-thead {
    background: #F5F5F5;
  }
  th, td {
    padding: 10px;
    vertical-align: middle;
    border: 1px solid black;
  }
  p {
    margin: 0;
    .el-form-item__error {
      top: 0;
    }
  }
  .cus-table-index {
    position: relative;
    &:before {
      content: "";
      width: 1px;
      height: 45px;
      display: block;
      position: absolute;
      top: -2px;
      left: 85px;
      border-right: 1px solid black;
      transform: rotate(152deg);
    }
  }
}
</style>